<div class="container-fluid content-container">
    <div class="content-container">
        <mat-card>
            <mat-card-content>
                <div class="header-container">
                    <div class="header-text">
                        <i class="bi bi-pen"></i>
                        <span>
                            &nbsp; Administración - Plantilla
                        </span>
                    </div>
                    <div class="header-controls" >
                        <button mat-button *ngFor="let control of controls" (click)="createInfo()">
                            <i [ngClass]="control.icon"></i>
                        </button>
                    </div>              
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="content-container" *ngIf="showdata">
        <mat-card>
            <mat-card class="template-container">
                <div class="template-header">
                    <span class="header-text template-header-items">Plantilla de correo</span>
                    <mat-form-field class="template-selection template-header-items">
                        <mat-select [(value)]="selectedTemplateType" (selectionChange)="setSelectedTemplate($event)">
                            <mat-option *ngFor="let emailTemplate of emailTemplates" [value]="emailTemplate.type">{{emailTemplate.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="template-body">
                    <div class="template-subject-form">
                        <mat-form-field style="width: 65%;">
                            <input matInput [(ngModel)]="selectedEmailTemplate.asunto">
                        </mat-form-field>
                       
                    </div>
                    <div class="template-editor">
                        <ckeditor 
                        [editor]="Editor" 
                        [disableWatchdog]="true"
                        [(ngModel)]="selectedEmailTemplate.content"
                        (ready)="editorsReady($event)"
                        [config]="configuration"
                        >
                    
                    </ckeditor>
                    
                    </div>
                    <div class="template-footer">
                        <mat-slide-toggle class="public-toggle" [labelPosition]="'before'"  [(ngModel)]="selectedEmailTemplate.isActive">
                            Publicado
                        </mat-slide-toggle>
                        <p>Última modificación: {{selectedEmailTemplate.datemodification}}</p>
                    </div>
                </div>
            </mat-card>
        </mat-card>
    </div>
</div>
